import { render } from "./ClosedSourceModels.vue?vue&type=template&id=0bc857c6&scoped=true"
import script from "./ClosedSourceModels.vue?vue&type=script&lang=js"
export * from "./ClosedSourceModels.vue?vue&type=script&lang=js"

import "./ClosedSourceModels.vue?vue&type=style&index=0&id=0bc857c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc857c6"]])

export default __exports__